export enum MenuOverrideTargetType {
    PRODUCT = 'product',
    MENU = 'menu',
    SECTION = 'section',
}

/**
 * Cuisine information of a restaurant.
 */
export enum Cuisine {
    CUISINE_UNSPECIFIED = 'CUISINE_UNSPECIFIED',
    AMERICAN = 'AMERICAN',
    ASIAN = 'ASIAN',
    BRAZILIAN = 'BRAZILIAN',
    BREAK_FAST = 'BREAK_FAST',
    BRUNCH = 'BRUNCH',
    CHICKEN = 'CHICKEN',
    CHINESE = 'CHINESE',
    FAMILY = 'FAMILY',
    FAST_FOOD = 'FAST_FOOD',
    FRENCH = 'FRENCH',
    GREEK = 'GREEK',
    GERMAN = 'GERMAN',
    HAMBURGER = 'HAMBURGER',
    INDIAN = 'INDIAN',
    INDONESIAN = 'INDONESIAN',
    ITALIAN = 'ITALIAN',
    JAPANESE = 'JAPANESE',
    KOREAN = 'KOREAN',
    LATIN_AMERICAN = 'LATIN_AMERICAN',
    MEDITERRANEAN = 'MEDITERRANEAN',
    MEXICAN = 'MEXICAN',
    PAKISTANI = 'PAKISTANI',
    PIZZA = 'PIZZA',
    SEAFOOD = 'SEAFOOD',
    SPANISH = 'SPANISH',
    SUSHI = 'SUSHI',
    THAI = 'THAI',
    TURKISH = 'TURKISH',
    VEGETARIAN = 'VEGETARIAN',
    VIETNAMESE = 'VIETNAMESE',
    OTHER_CUISINE = 'OTHER_CUISINE',
}

/**
 * Dietary information of a food item.
 */
export enum DietaryRestriction {
    DIETARY_RESTRICTION_UNSPECIFIED = 'DIETARY_RESTRICTION_UNSPECIFIED',
    HALAL = 'HALAL',
    KOSHER = 'KOSHER',
    ORGANIC = 'ORGANIC',
    VEGAN = 'VEGAN',
    VEGETARIAN = 'VEGETARIAN',
}

/**
 * Allergen information regarding a food item.
 */
export enum Allergen {
    ALLERGEN_UNSPECIFIED = 'ALLERGEN_UNSPECIFIED',
    DAIRY = 'DAIRY',
    EGG = 'EGG',
    FISH = 'FISH',
    PEANUT = 'PEANUT',
    SHELLFISH = 'SHELLFISH',
    SOY = 'SOY',
    TREE_NUT = 'TREE_NUT',
    WHEAT = 'WHEAT',
}
